import { render } from "./HelloWorld.vue?vue&type=template&id=706e098c&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=706e098c&scoped=true&lang=scss"

import exportComponent from "/Users/mmartinez/Desktop/personal/suburban relapse/suburban-relapse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706e098c"]])

export default __exports__